var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import sharedMessages from 'translations/shared';
import { Typography, Input } from '@petsly/shared-client';
var View = function (_a) {
    var messages = _a.messages, changeInput = _a.changeInput, filterOptions = _a.filterOptions;
    var formatMessage = useIntl().formatMessage;
    return (_jsxs(Item, { children: [_jsx(Heading, { children: formatMessage(sharedMessages.search) }, void 0), _jsx(InputWrapper, { children: _jsx(Input, { onChange: function (ev) {
                        changeInput(ev.currentTarget.value);
                    }, placeholder: formatMessage(messages.searchPlaceholder), value: filterOptions.query }, void 0) }, void 0)] }, void 0));
};
export default View;
var Item = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var InputWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Heading = styled(Typography).attrs({
    size: 'h100',
    variant: 'secondary',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
